/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import Link from './Link';
import {createURLWithParams} from '../util';
import Button, {ButtonTypes} from './ButtonNew';

const QuestionCard = ({tag, trackerEvent, urlParams}) => {
  let url;
  let formattedName;
  if (tag.type === 'company') {
    url = `/questions?company=${tag.id}`;
    formattedName = tag.name;
  } else if (tag.type === 'role') {
    url = `/questions?role=${tag.id}`;
    formattedName = tag.name.toLowerCase();
  }
  const link = createURLWithParams(url, urlParams);

  const handleClick = () => {
    trackerEvent?.();
  };

  return (
    <div
      className="-mx-2 cursor-pointer mt-4 py-4 px-4 border border-gray-200 rounded-lg"
      onClick={handleClick}
    >
      {tag.type === 'company' && tag.image_url && (
        <div className="flex justify-between mb-1">
          <img
            className="w-6 h-6 rounded-full mr-4 object-cover"
            src={tag.image_url}
            alt={tag.name}
            loading="lazy"
          />
        </div>
      )}
      {url ? (
        <Link href={url}>
          <h3 className="text-lg font-semibold mb-1 leading-tight tracking-tight">
            {`Browse ${formattedName} interview questions`}
          </h3>
        </Link>
      ) : (
        <h3 className="text-lg font-semibold mb-1 leading-tight tracking-tight">
          {`Browse ${formattedName} interview questions`}
        </h3>
      )}
      <div className="text-sm text-gray-500 font-regular mb-3">
        {`Review recently asked ${formattedName} interview questions and answers from real candidates.`}
      </div>
      <Button
        onClick={handleClick}
        href={link}
        target="_blank"
        buttonType={ButtonTypes.SECONDARY}
        className="w-full"
      >
        {'Browse questions ->'}
      </Button>
    </div>
  );
};

export default QuestionCard;
